import { createListenerMiddleware } from '@reduxjs/toolkit'
import { initSyncMemberEligiblityListener } from '@pages/InsuranceMember/components/SyncInsurance/helpers/syncMemberEligibilityListener'
import { initLoginSyncActionListener } from '@pages/InsuranceMember/components/SyncInsurance/helpers/loginSyncActionListener'

export const listenerMiddleware = createListenerMiddleware()

initSyncMemberEligiblityListener(listenerMiddleware)
initLoginSyncActionListener(listenerMiddleware)
